export default {"src":"/_next/static/image/public/images/ic_share_white.5d66156b683e1f5e1def9d5019674251.svg","height":21,"width":18};